// extracted by mini-css-extract-plugin
export default {"Image":"SoftLaunchModal_Image__bzmUk","BodyCopyWrapper":"SoftLaunchModal_BodyCopyWrapper__T5gd5"};